module.exports = __webpack_public_path__ + "img/2023102701.255f5680.webp";